module.exports = __webpack_public_path__ + "img/13.75d5b970.jpg";